(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sidefill-engraving-funnel"] && !Shopify.designMode) return;
  try {
    
  class SidefillEngravingFunnel extends HTMLElement {
    connectedCallback() {
      this.product = this.readJson('[data-funnel-product]');
      this.sleeve = this.readJson('[data-funnel-sleeve]');
      this.availableVariants = (this.product?.variants || []).filter((variant) => variant.available);
      this.discountThreshold = Number(this.dataset.discountThreshold || 3);
      this.discountPercent = Number(this.dataset.discountPercent || 20);
      this.maxCharacters = Number(this.dataset.maxCharacters || 10);
      this.state = { quantity: 0, colorMode: '', variantIds: [], engravings: [], sleeveChoice: '', sleeveQuantity: 0, sleeveColorMode: '', sleeveColorCounts: {} };
      this.editingColorIndex = null;
      this.activeColorIndex = 0;
      this.activeEngravingIndex = 0;
      this.confirmingColorIndex = null;
      this.colorAdvanceTimer = null;
      this.progressLabels = {
        quantity: this.querySelector('[data-step="quantity"] h2')?.textContent.trim() || '',
        colors: this.querySelector('[data-step="colors"] h2')?.textContent.trim() || '',
        engraving: this.querySelector('[data-step="engraving"] h2')?.textContent.trim() || '',
        sleeve: this.querySelector('[data-step="sleeve"] h2')?.textContent.trim() || '',
        summary: this.querySelector('[data-step="summary"] h2')?.textContent.trim() || ''
      };
      this.refs = {
        colorGroups: this.querySelector('[data-color-groups]'),
        engravingList: this.querySelector('[data-engraving-list]'),
        copyAllWrap: this.querySelector('[data-copy-all-wrap]'),
        copyAll: this.querySelector('[data-copy-all]'),
        sleeveOptions: this.querySelector('[data-sleeve-options]'),
        sleeveYesCard: this.querySelector('[data-sleeve-yes-card]'),
        summary: this.querySelector('[data-summary]'),
        add: this.querySelector('[data-add-to-cart]'),
        cartError: this.querySelector('[data-cart-error]'),
        status: this.querySelector('[data-funnel-status]'),
        progress: this.querySelector('[data-progress]'),
        progressFill: this.querySelector('[data-progress-fill]'),
        progressLabel: this.querySelector('[data-progress-label]'),
        progressCount: this.querySelector('[data-progress-count]')
      };
      this.storageKey = `sidefill-engraving-funnel:${this.product?.id || 'product'}:v6`;
      if (!this.availableVariants.length) {
        this.showStatus(this.dataset.labelConfigurationError);
        return;
      }
      if (!this.sleeve?.variants?.some((variant) => variant.available) && this.refs.sleeveYesCard) {
        this.refs.sleeveYesCard.hidden = true;
      }
      this.bindEvents();
      this.renderTierPrices();
      this.restoreState();
    }

    readJson(selector) {
      const node = this.querySelector(selector);
      if (!node) return null;
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return null;
      }
    }

    bindEvents() {
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-quantity]')) this.selectQuantity(Number(event.target.value));
        if (event.target.matches('[data-color-mode]')) this.selectColorMode(event.target.value);
        if (event.target.matches('[data-copy-all]')) this.applyCopyAll();
        if (event.target.matches('[data-sleeve-choice]')) this.selectSleeve(event.target.value === 'yes');
      });
      this.addEventListener('click', (event) => {
        const color = event.target.closest('[data-color-index][data-variant-id]');
        const colorEdit = event.target.closest('[data-color-edit]');
        const sleeveQuantity = event.target.closest('[data-sleeve-quantity]');
        const sleeveColorMode = event.target.closest('[data-sleeve-color-mode]');
        const sleeveAllColor = event.target.closest('[data-sleeve-all-color]');
        const sleeveCountChange = event.target.closest('[data-sleeve-count-change]');
        const previous = event.target.closest('[data-engraving-previous]');
        const next = event.target.closest('[data-engraving-next]');
        if (color) this.selectColor(Number(color.dataset.colorIndex), color.dataset.variantId);
        if (colorEdit) this.editColor(Number(colorEdit.dataset.colorEdit));
        if (sleeveQuantity) this.selectSleeveQuantity(Number(sleeveQuantity.dataset.sleeveQuantity));
        if (sleeveColorMode) this.selectSleeveColorMode(sleeveColorMode.dataset.sleeveColorMode);
        if (sleeveAllColor) this.selectAllSleevesColor(sleeveAllColor.dataset.sleeveAllColor);
        if (sleeveCountChange) this.changeSleeveColorCount(sleeveCountChange.dataset.sleeveVariantId, Number(sleeveCountChange.dataset.sleeveCountChange));
        if (previous) this.showEngraving(Number(previous.dataset.engravingPrevious), true);
        if (next) this.advanceEngraving(Number(next.dataset.engravingNext));
        if (event.target.closest('[data-add-to-cart]')) this.addToCart();
      });
      this.addEventListener('input', (event) => {
        if (event.target.matches('[data-engraving-input]')) {
          this.updateEngraving(Number(event.target.dataset.engravingInput), event.target.value);
        }
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && event.target.matches('[data-engraving-input]')) {
          event.preventDefault();
          this.advanceEngraving(Number(event.target.dataset.engravingInput));
        }
      });
    }

    selectQuantity(quantity) {
      this.cancelColorAdvance();
      this.state.quantity = quantity;
      this.state.variantIds = Array(quantity).fill('');
      this.state.engravings = Array(quantity).fill('');
      this.state.colorMode = '';
      this.state.sleeveChoice = '';
      this.state.sleeveQuantity = 0;
      this.state.sleeveColorMode = '';
      this.state.sleeveColorCounts = {};
      this.activeColorIndex = 0;
      this.activeEngravingIndex = 0;
      this.querySelectorAll('[data-color-mode], [data-sleeve-choice]').forEach((input) => { input.checked = false; });
      this.lockFrom('color-mode');
      this.unlock('color-mode');
      this.setProgress(2, 'colors');
      this.persist();
      this.scrollToStep('color-mode');
    }

    selectColorMode(mode) {
      this.cancelColorAdvance();
      this.state.colorMode = mode;
      this.state.variantIds = Array(this.state.quantity).fill('');
      this.state.engravings = Array(this.state.quantity).fill('');
      this.activeColorIndex = 0;
      this.activeEngravingIndex = 0;
      this.lockFrom('colors');
      this.unlock('colors');
      this.renderColors();
      this.persist();
      this.scrollToStep('colors');
    }

    renderColors() {
      const groupCount = this.state.colorMode === 'same' ? 1 : this.state.quantity;
      this.refs.colorGroups.innerHTML = Array.from({ length: groupCount }, (_, index) => {
        const title = this.state.colorMode === 'same'
          ? this.progressLabels.colors
          : `${this.dataset.labelColorFor} ${index + 1}`;
        const selectedId = this.state.variantIds[index] || '';
        const selectedVariant = selectedId ? this.variantById(selectedId) : null;
        const swatches = (this.product.variants || []).map((variant) => {
          const unavailable = variant.available ? '' : `<small>${this.escape(this.dataset.labelUnavailable)}</small>`;
          return `<button type="button" class="engraving-funnel__swatch" data-color-index="${index}" data-variant-id="${this.escape(variant.id)}" aria-pressed="${String(selectedId) === String(variant.id)}" ${variant.available ? '' : 'disabled'}><span class="engraving-funnel__swatch-dot" style="background:${this.escape(variant.swatch)}"></span><span class="engraving-funnel__swatch-copy">${this.escape(variant.color)}${unavailable}</span><span class="engraving-funnel__swatch-check" aria-hidden="true">✓</span></button>`;
        }).join('');
        const selectedCopy = selectedVariant ? `<p class="engraving-funnel__selected-color" aria-live="polite"><span>✓</span><strong>${this.escape(this.dataset.labelSelectedColor)}:</strong> ${this.escape(selectedVariant.color)}</p>` : '';
        return `<div class="engraving-funnel__color-group${selectedId ? ' is-complete' : ''}${index === this.activeColorIndex ? ' is-active' : ''}${index === this.confirmingColorIndex ? ' is-confirming' : ''}" data-color-group="${index}" tabindex="-1"><h3>${this.escape(title)}</h3><div class="engraving-funnel__swatches">${swatches}</div>${selectedCopy}</div>`;
      }).join('');
    }

    selectColor(index, variantId) {
      if (this.colorAdvanceTimer) return;
      if (this.state.colorMode === 'same') {
        this.state.variantIds = Array(this.state.quantity).fill(variantId);
      } else {
        this.state.variantIds[index] = variantId;
      }
      this.lockFrom('engraving');
      this.activeColorIndex = this.state.colorMode === 'same' ? 0 : index;
      this.confirmingColorIndex = this.activeColorIndex;
      this.renderColors();
      this.persist();
      this.colorAdvanceTimer = window.setTimeout(() => {
        this.colorAdvanceTimer = null;
        this.confirmingColorIndex = null;
        const nextIndex = this.state.colorMode === 'mixed' ? this.state.variantIds.findIndex((id) => !id) : -1;
        if (nextIndex !== -1) {
          this.activeColorIndex = nextIndex;
          this.renderColors();
          const nextGroup = this.querySelector(`[data-color-group="${nextIndex}"]`);
          window.setTimeout(() => this.scrollToElement(nextGroup), 60);
          return;
        }
        this.completeColorStep();
      }, 420);
    }

    cancelColorAdvance() {
      if (this.colorAdvanceTimer) window.clearTimeout(this.colorAdvanceTimer);
      this.colorAdvanceTimer = null;
      this.confirmingColorIndex = null;
    }

    completeColorStep() {
      this.unlock('engraving');
      const returnIndex = this.editingColorIndex;
      this.editingColorIndex = null;
      this.activeEngravingIndex = Number.isInteger(returnIndex) ? returnIndex : 0;
      this.renderEngravings();
      this.setProgress(3, 'engraving');
      if (Number.isInteger(returnIndex)) {
        this.querySelectorAll('[data-step]').forEach((step) => step.classList.remove('is-current'));
        this.querySelector('[data-step="engraving"]')?.classList.add('is-current');
        window.setTimeout(() => this.showEngraving(returnIndex, true), 120);
        return;
      }
      this.scrollToStep('engraving');
      window.setTimeout(() => this.showEngraving(0, true), 420);
    }

    editColor(index) {
      this.cancelColorAdvance();
      const groupIndex = this.state.colorMode === 'same' ? 0 : index;
      this.editingColorIndex = index;
      this.activeColorIndex = groupIndex;
      this.lockFrom('engraving');
      this.renderColors();
      this.setProgress(2, 'colors');
      this.persist();
      this.querySelectorAll('[data-step]').forEach((step) => step.classList.remove('is-current'));
      this.querySelector('[data-step="colors"]')?.classList.add('is-current');
      const group = this.querySelector(`[data-color-group="${groupIndex}"]`);
      window.setTimeout(() => this.scrollToElement(group), 180);
    }

    renderEngravings() {
      this.refs.copyAllWrap.hidden = this.state.quantity < 2;
      this.refs.engravingList.innerHTML = this.state.variantIds.map((variantId, index) => {
        const variant = this.variantById(variantId);
        const value = this.state.engravings[index] || '';
        const valid = this.isValidEngraving(value);
        const x = this.percent(variant.textX, variant.canvasWidth, 50);
        const y = this.percent(variant.textY, variant.canvasHeight, 78);
        const width = this.percent(variant.textMaxWidth, variant.canvasWidth, 31);
        const previousButton = index > 0 ? `<button type="button" class="engraving-funnel__previous" data-engraving-previous="${index - 1}">${this.escape(this.dataset.labelPreviousBottle)}</button>` : '';
        return `<article class="engraving-funnel__engraving-card${valid ? ' is-complete' : ''}${index === this.activeEngravingIndex ? ' is-active' : ''}" data-engraving-card="${index}" tabindex="-1"><div class="engraving-funnel__preview"><img src="${this.escape(variant.previewImage)}" alt="${this.escape(variant.color)}" width="600" height="600"><span class="engraving-funnel__preview-text" data-preview-text="${index}" style="--preview-x:${x}%;--preview-y:${y}%;--preview-width:${width}%;--preview-opacity:${Number(variant.textOpacity || 0.85)};--preview-rotation:${Number(variant.textRotation || 0)}deg;color:${this.escape(variant.textColor || '#CACCCE')};mix-blend-mode:${this.safeBlendMode(variant.blendMode)}">${this.escape(value || this.dataset.labelPreview)}</span></div><div class="engraving-funnel__engraving-form"><h3>${this.escape(this.dataset.labelBottle)} ${index + 1}</h3><button type="button" class="engraving-funnel__color-edit" data-color-edit="${index}" aria-label="${this.escape(this.dataset.labelChangeColor)}: ${this.escape(variant.color)}"><span class="engraving-funnel__color-edit-dot" style="background:${this.escape(variant.swatch)}"></span><strong>${this.escape(variant.color)}</strong><small>${this.escape(this.dataset.labelChangeColor)}</small></button><label for="EngravingText-${this.id}-${index}">${this.escape(this.dataset.labelEngraving)}</label><input id="EngravingText-${this.id}-${index}" class="engraving-funnel__engraving-input" type="text" value="${this.escape(value)}" maxlength="${this.maxCharacters}" autocomplete="off" autocapitalize="words" spellcheck="false" enterkeyhint="${index === this.state.quantity - 1 ? 'done' : 'next'}" data-engraving-input="${index}" placeholder="${this.escape(this.dataset.labelPlaceholder)}" aria-describedby="EngravingMeta-${this.id}-${index}"><div id="EngravingMeta-${this.id}-${index}" class="engraving-funnel__field-meta"><span class="engraving-funnel__field-error" data-field-error="${index}"></span><span data-character-count="${index}">${value.length} / ${this.maxCharacters}</span></div><div class="engraving-funnel__engraving-actions">${previousButton}<button type="button" class="engraving-funnel__next" data-engraving-next="${index}" ${valid ? '' : 'disabled'}>${this.escape(index === this.state.quantity - 1 ? this.dataset.labelNextSleeve : this.dataset.labelNext)}</button></div></div></article>`;
      }).join('');
    }

    updateEngraving(index, rawValue) {
      const value = rawValue.slice(0, this.maxCharacters);
      this.state.engravings[index] = value;
      if (this.refs.copyAll.checked && index === 0) {
        this.state.engravings = Array(this.state.quantity).fill(value);
      }
      this.syncEngravingCards();
      this.persist();
    }

    syncEngravingCards() {
      this.state.engravings.forEach((value, index) => {
        const input = this.querySelector(`[data-engraving-input="${index}"]`);
        const preview = this.querySelector(`[data-preview-text="${index}"]`);
        const count = this.querySelector(`[data-character-count="${index}"]`);
        const error = this.querySelector(`[data-field-error="${index}"]`);
        const button = this.querySelector(`[data-engraving-next="${index}"]`);
        const card = this.querySelector(`[data-engraving-card="${index}"]`);
        const valid = this.isValidEngraving(value);
        if (input && input.value !== value) input.value = value;
        if (preview) {
          preview.textContent = value || this.dataset.labelPreview;
          preview.classList.remove('is-updating');
          requestAnimationFrame(() => preview.classList.add('is-updating'));
        }
        if (count) count.textContent = `${value.length} / ${this.maxCharacters}`;
        if (error) error.textContent = value && !valid ? this.dataset.labelInvalid : '';
        if (button) button.disabled = !valid;
        if (card) card.classList.toggle('is-complete', valid);
      });
    }

    applyCopyAll() {
      if (this.refs.copyAll.checked && this.state.engravings[0]) {
        this.state.engravings = Array(this.state.quantity).fill(this.state.engravings[0]);
        this.syncEngravingCards();
        this.persist();
      }
    }

    advanceEngraving(index) {
      const value = this.state.engravings[index] || '';
      const input = this.querySelector(`[data-engraving-input="${index}"]`);
      if (!this.isValidEngraving(value)) {
        input?.focus();
        return;
      }
      if (index < this.state.quantity - 1 && !this.refs.copyAll.checked) {
        this.showEngraving(index + 1, true);
        return;
      }
      if (this.state.engravings.every((engraving) => this.isValidEngraving(engraving))) {
        this.unlock('sleeve');
        this.setProgress(4, 'sleeve');
        this.scrollToStep('sleeve');
      }
    }

    showEngraving(index, focusInput = false) {
      this.activeEngravingIndex = Math.min(Math.max(index, 0), this.state.quantity - 1);
      this.querySelectorAll('[data-engraving-card]').forEach((card) => {
        card.classList.toggle('is-active', Number(card.dataset.engravingCard) === this.activeEngravingIndex);
      });
      const card = this.querySelector(`[data-engraving-card="${this.activeEngravingIndex}"]`);
      window.setTimeout(() => {
        this.scrollToElement(card);
        if (focusInput) window.setTimeout(() => this.querySelector(`[data-engraving-input="${this.activeEngravingIndex}"]`)?.focus(), 320);
      }, 60);
    }

    selectSleeve(includeSleeve) {
      this.state.sleeveChoice = includeSleeve ? 'yes' : 'no';
      this.state.sleeveQuantity = 0;
      this.state.sleeveColorMode = '';
      this.state.sleeveColorCounts = {};
      this.lockFrom('summary');
      this.refs.sleeveOptions.hidden = !includeSleeve;
      if (!includeSleeve) {
        this.renderSummary();
        this.unlock('summary');
        this.setProgress(5, 'summary');
        this.persist();
        this.scrollToStep('summary');
        return;
      }
      this.setProgress(4, 'sleeve');
      this.renderSleeveOptions();
      this.persist();
      window.setTimeout(() => this.scrollToElement(this.refs.sleeveOptions), 180);
    }

    renderSleeveOptions() {
      const variants = (this.sleeve?.variants || []).filter((variant) => variant.available);
      const quantities = Array.from({ length: this.state.quantity }, (_, index) => {
        const quantity = index + 1;
        const label = quantity === 1 ? this.dataset.labelSleeve : this.dataset.labelSleeves;
        return `<button type="button" class="engraving-funnel__sleeve-quantity-button" data-sleeve-quantity="${quantity}" aria-pressed="${quantity === this.state.sleeveQuantity}"><strong>${quantity}</strong><small>${this.escape(label)}</small></button>`;
      }).join('');
      const modeChoices = this.state.sleeveQuantity > 0 ? `<fieldset class="engraving-funnel__sleeve-color-mode" data-sleeve-mode-panel><legend>${this.escape(this.dataset.labelSleeveColorModeTitle)}</legend><div class="engraving-funnel__sleeve-mode-grid"><button type="button" class="engraving-funnel__sleeve-mode" data-sleeve-color-mode="same" aria-pressed="${this.state.sleeveColorMode === 'same'}"><strong>${this.escape(this.dataset.labelSameSleeveColors)}</strong><small>${this.escape(this.dataset.labelSameSleeveColorsText)}</small></button><button type="button" class="engraving-funnel__sleeve-mode" data-sleeve-color-mode="split" aria-pressed="${this.state.sleeveColorMode === 'split'}"><strong>${this.escape(this.dataset.labelSplitSleeveColors)}</strong><small>${this.escape(this.dataset.labelSplitSleeveColorsText)}</small></button></div></fieldset>` : '';
      let colorPanel = '';
      if (this.state.sleeveColorMode === 'same') {
        const selectedId = Object.keys(this.state.sleeveColorCounts).find((id) => Number(this.state.sleeveColorCounts[id]) > 0) || '';
        const options = variants.map((variant) => `<button type="button" class="engraving-funnel__sleeve-variant" data-sleeve-all-color="${this.escape(variant.id)}" aria-pressed="${String(selectedId) === String(variant.id)}"><img src="${this.escape(variant.image)}" alt="" width="104" height="104"><span><strong>${this.escape(variant.title)}</strong><br><small>${this.money(variant.price)} × ${this.state.sleeveQuantity}</small></span><span class="engraving-funnel__sleeve-variant-check" aria-hidden="true">${String(selectedId) === String(variant.id) ? '✓' : ''}</span></button>`).join('');
        colorPanel = `<div class="engraving-funnel__sleeve-variants" data-sleeve-color-panel>${options}</div>`;
      }
      if (this.state.sleeveColorMode === 'split') {
        const total = this.sleeveCountTotal();
        const rows = variants.map((variant) => {
          const count = Number(this.state.sleeveColorCounts[String(variant.id)] || 0);
          return `<div class="engraving-funnel__sleeve-distribution-row"><div class="engraving-funnel__sleeve-distribution-copy"><img src="${this.escape(variant.image)}" alt="" width="96" height="96"><span><strong>${this.escape(variant.title)}</strong><br><small>${this.money(variant.price)}</small></span></div><div class="engraving-funnel__sleeve-stepper"><button type="button" data-sleeve-count-change="-1" data-sleeve-variant-id="${this.escape(variant.id)}" aria-label="${this.escape(this.dataset.labelDecreaseSleeve)} ${this.escape(variant.title)}" ${count > 0 ? '' : 'disabled'}>−</button><strong aria-live="polite">${count}</strong><button type="button" data-sleeve-count-change="1" data-sleeve-variant-id="${this.escape(variant.id)}" aria-label="${this.escape(this.dataset.labelIncreaseSleeve)} ${this.escape(variant.title)}" ${total < this.state.sleeveQuantity ? '' : 'disabled'}>+</button></div></div>`;
        }).join('');
        colorPanel = `<div class="engraving-funnel__sleeve-distribution" data-sleeve-color-panel>${rows}<p class="engraving-funnel__sleeve-distribution-status" aria-live="polite">${this.escape(this.dataset.labelSleeveDistribution)}: <strong>${total} / ${this.state.sleeveQuantity}</strong></p></div>`;
      }
      this.refs.sleeveOptions.innerHTML = `<fieldset class="engraving-funnel__sleeve-quantity"><legend>${this.escape(this.dataset.labelSleeveQuantityTitle)}</legend><p>${this.escape(this.dataset.labelSleeveQuantityText)}</p><div class="engraving-funnel__sleeve-quantity-grid">${quantities}</div></fieldset>${modeChoices}${colorPanel}`;
      this.refs.sleeveOptions.hidden = false;
    }

    selectSleeveQuantity(quantity) {
      this.state.sleeveQuantity = quantity;
      this.state.sleeveColorMode = '';
      this.state.sleeveColorCounts = {};
      this.lockFrom('summary');
      this.setProgress(4, 'sleeve');
      this.renderSleeveOptions();
      this.persist();
      window.setTimeout(() => this.scrollToElement(this.querySelector('[data-sleeve-mode-panel]')), 120);
    }

    selectSleeveColorMode(mode) {
      if (!['same', 'split'].includes(mode)) return;
      this.state.sleeveColorMode = mode;
      this.state.sleeveColorCounts = {};
      this.lockFrom('summary');
      this.setProgress(4, 'sleeve');
      this.renderSleeveOptions();
      this.persist();
      window.setTimeout(() => this.scrollToElement(this.querySelector('[data-sleeve-color-panel]')), 120);
    }

    selectAllSleevesColor(variantId) {
      if (!this.sleeveVariantById(variantId)) return;
      this.state.sleeveColorCounts = { [String(variantId)]: this.state.sleeveQuantity };
      this.renderSleeveOptions();
      this.persist();
      this.completeSleeveStep();
    }

    changeSleeveColorCount(variantId, delta) {
      if (!this.sleeveVariantById(variantId) || ![-1, 1].includes(delta)) return;
      const id = String(variantId);
      const current = Number(this.state.sleeveColorCounts[id] || 0);
      const total = this.sleeveCountTotal();
      if (delta > 0 && total >= this.state.sleeveQuantity) return;
      const next = Math.max(0, current + delta);
      if (next > 0) this.state.sleeveColorCounts[id] = next;
      else delete this.state.sleeveColorCounts[id];
      this.lockFrom('summary');
      this.setProgress(4, 'sleeve');
      this.renderSleeveOptions();
      this.persist();
      if (this.sleevesComplete()) window.setTimeout(() => this.completeSleeveStep(), 300);
    }

    completeSleeveStep() {
      if (!this.sleevesComplete()) return;
      this.renderSummary();
      this.unlock('summary');
      this.setProgress(5, 'summary');
      this.persist();
      this.scrollToStep('summary');
    }

    renderSummary() {
      const rows = this.state.variantIds.map((variantId, index) => {
        const variant = this.variantById(variantId);
        return `<li><span><strong>${this.escape(this.dataset.labelBottle)} ${index + 1}</strong><small>${this.escape(variant.color)} · ${this.escape(this.state.engravings[index])}</small></span><strong>${this.money(variant.price)}</strong></li>`;
      }).join('');
      const bottleSubtotal = this.state.variantIds.reduce((sum, id) => sum + Number(this.variantById(id).price || 0), 0);
      const discount = this.state.quantity >= this.discountThreshold ? Math.round(bottleSubtotal * this.discountPercent / 100) : 0;
      const sleeveEntries = Object.entries(this.state.sleeveColorCounts || {}).filter(([variantId, count]) => Number(count) > 0 && this.sleeveVariantById(variantId));
      const sleeveTotal = sleeveEntries.reduce((sum, [variantId, count]) => sum + Number(this.sleeveVariantById(variantId)?.price || 0) * Number(count), 0);
      const sleeveRow = this.state.sleeveQuantity > 0
        ? sleeveEntries.map(([variantId, count]) => {
          const variant = this.sleeveVariantById(variantId);
          return `<li><span><strong>${this.escape(this.dataset.labelSleeve)} × ${Number(count)}</strong><small>${this.escape(variant.title)}</small></span><strong>${this.money(Number(variant.price) * Number(count))}</strong></li>`;
        }).join('')
        : `<li><span><strong>${this.escape(this.dataset.labelSleeve)}</strong><small>${this.escape(this.dataset.labelNoSleeve)}</small></span><strong>—</strong></li>`;
      const discountRow = discount > 0 ? `<div class="engraving-funnel__total-row is-discount"><span>${this.escape(this.dataset.labelDiscount)} (${this.discountPercent} %)</span><strong>− ${this.money(discount)}</strong></div>` : '';
      this.refs.summary.innerHTML = `<ul class="engraving-funnel__summary-list">${rows}${sleeveRow}</ul><div class="engraving-funnel__totals"><div class="engraving-funnel__total-row"><span>${this.escape(this.dataset.labelSubtotal)}</span><strong>${this.money(bottleSubtotal + sleeveTotal)}</strong></div>${discountRow}<div class="engraving-funnel__total-row is-total"><span>${this.escape(this.dataset.labelTotal)}</span><strong>${this.money(bottleSubtotal + sleeveTotal - discount)}</strong></div></div>`;
    }

    async addToCart() {
      if (!this.configurationComplete()) {
        this.showCartError(this.dataset.labelConfigurationError);
        return;
      }
      const groupId = globalThis.crypto?.randomUUID?.() || `engraving-${Date.now()}`;
      const items = this.state.variantIds.map((variantId, index) => {
        const variant = this.variantById(variantId);
        return {
          id: Number(String(variant.id).split('/').pop()),
          quantity: 1,
          properties: {
            Gravur: this.state.engravings[index],
            Flasche: `${index + 1} / ${this.state.quantity}`,
            Farbe: variant.color,
            _personalized: 'true',
            _engraving_text: this.state.engravings[index],
            _engraving_config_id: variant.configId,
            _bundle_group_id: groupId,
            _bundle_plan: String(this.state.quantity),
            _funnel_version: '2026-07-22'
          }
        };
      });
      Object.entries(this.state.sleeveColorCounts || {}).forEach(([variantId, count]) => {
        const sleeveVariant = this.sleeveVariantById(variantId);
        if (!sleeveVariant || Number(count) < 1) return;
        items.push({
          id: Number(String(sleeveVariant.id).split('/').pop()),
          quantity: Number(count),
          properties: {
            Farbe: sleeveVariant.title,
            _sleeve_color_mode: this.state.sleeveColorMode,
            _bundle_group_id: groupId,
            _funnel_version: '2026-07-22-simple-sleeves'
          }
        });
      });
      this.refs.add.disabled = true;
      this.refs.add.textContent = this.dataset.labelAdding;
      this.refs.cartError.hidden = true;
      try {
        const response = await fetch(this.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error(await response.text());
        sessionStorage.removeItem(this.storageKey);
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.refs.add.disabled = false;
        this.refs.add.textContent = this.dataset.labelAddToCart;
        this.showCartError(this.dataset.labelCartError);
      }
    }

    configurationComplete() {
      const bottlesReady = this.state.quantity > 0 && this.state.variantIds.length === this.state.quantity && this.state.variantIds.every(Boolean) && this.state.engravings.every((engraving) => this.isValidEngraving(engraving));
      const sleeveReady = this.state.sleeveChoice === 'no' || (this.state.sleeveChoice === 'yes' && this.sleevesComplete());
      return bottlesReady && sleeveReady;
    }

    sleevesComplete() {
      const countsAreValid = Object.entries(this.state.sleeveColorCounts || {}).every(([variantId, count]) => this.sleeveVariantById(variantId)?.available && Number.isInteger(Number(count)) && Number(count) > 0);
      return this.state.sleeveQuantity > 0 && this.state.sleeveQuantity <= this.state.quantity && ['same', 'split'].includes(this.state.sleeveColorMode) && countsAreValid && this.sleeveCountTotal() === this.state.sleeveQuantity;
    }

    sleeveCountTotal() {
      return Object.values(this.state.sleeveColorCounts || {}).reduce((sum, count) => sum + Math.max(0, Number(count) || 0), 0);
    }

    renderTierPrices() {
      const basePrice = Number(this.availableVariants[0]?.price || 0);
      this.querySelectorAll('[data-tier-price]').forEach((node) => {
        const quantity = Number(node.dataset.tierPrice);
        const subtotal = basePrice * quantity;
        const discount = quantity >= this.discountThreshold ? Math.round(subtotal * this.discountPercent / 100) : 0;
        node.textContent = this.money(subtotal - discount);
      });
    }

    variantById(id) {
      return this.product.variants.find((variant) => String(variant.id) === String(id)) || this.availableVariants[0];
    }

    sleeveVariantById(id) {
      return (this.sleeve?.variants || []).find((variant) => String(variant.id) === String(id)) || null;
    }

    isValidEngraving(value) {
      const trimmed = String(value || '').trim();
      return Boolean(trimmed) && trimmed.length <= this.maxCharacters && /^[\p{L}\p{N} .&+\-]+$/u.test(trimmed);
    }

    percent(value, total, fallback) {
      const number = Number(value);
      const maximum = Number(total);
      if (!number || !maximum) return fallback;
      return Math.round(number / maximum * 10000) / 100;
    }

    safeBlendMode(value) {
      return ['normal', 'multiply', 'screen', 'overlay', 'darken', 'lighten'].includes(value) ? value : 'normal';
    }

    money(cents) {
      return new Intl.NumberFormat(this.dataset.locale || 'de-CH', { style: 'currency', currency: this.dataset.currency || 'CHF' }).format(Number(cents || 0) / 100);
    }

    unlock(stepName) {
      const step = this.querySelector(`[data-step="${stepName}"]`);
      if (!step) return;
      step.classList.remove('is-locked');
      step.classList.add('is-unlocked');
      step.setAttribute('aria-disabled', 'false');
    }

    lockFrom(stepName) {
      const order = ['color-mode', 'colors', 'engraving', 'sleeve', 'summary'];
      const start = order.indexOf(stepName);
      order.slice(Math.max(start, 0)).forEach((name) => {
        const step = this.querySelector(`[data-step="${name}"]`);
        if (!step) return;
        step.classList.add('is-locked');
        step.classList.remove('is-unlocked', 'is-current');
        step.setAttribute('aria-disabled', 'true');
      });
    }

    scrollToStep(stepName) {
      this.querySelectorAll('[data-step]').forEach((step) => step.classList.remove('is-current'));
      const step = this.querySelector(`[data-step="${stepName}"]`);
      if (!step) return;
      step.classList.add('is-current');
      window.setTimeout(() => this.scrollToElement(step), 180);
    }

    scrollToElement(element) {
      if (!element) return;
      const offset = window.matchMedia('(max-width: 749px)').matches ? 96 : 112;
      element.focus({ preventScroll: false });
      window.requestAnimationFrame(() => {
        const scrollRoot = document.scrollingElement || document.documentElement;
        const top = scrollRoot.scrollTop + element.getBoundingClientRect().top - offset;
        scrollRoot.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    }

    setProgress(step, labelKey) {
      this.refs.progress.setAttribute('aria-valuenow', String(step));
      this.refs.progressFill.style.width = `${step * 20}%`;
      this.refs.progressCount.textContent = `${step} / 5`;
      this.refs.progressLabel.textContent = this.progressLabels[labelKey] || '';
    }

    persist() {
      try {
        sessionStorage.setItem(this.storageKey, JSON.stringify(this.state));
      } catch (error) {
        return;
      }
    }

    restoreState() {
      let saved = null;
      try {
        saved = JSON.parse(sessionStorage.getItem(this.storageKey));
      } catch (error) {
        saved = null;
      }
      if (!saved?.quantity) return;
      const quantityInput = this.querySelector(`[data-quantity][value="${Number(saved.quantity)}"]`);
      if (!quantityInput) return;
      quantityInput.checked = true;
      this.selectQuantity(Number(saved.quantity));
      if (!['same', 'mixed'].includes(saved.colorMode)) return;
      const modeInput = this.querySelector(`[data-color-mode][value="${saved.colorMode}"]`);
      if (modeInput) modeInput.checked = true;
      this.state.colorMode = saved.colorMode;
      this.state.variantIds = Array.isArray(saved.variantIds) ? saved.variantIds.slice(0, this.state.quantity) : [];
      while (this.state.variantIds.length < this.state.quantity) this.state.variantIds.push('');
      this.state.variantIds = this.state.variantIds.map((id) => this.product.variants.some((variant) => String(variant.id) === String(id) && variant.available) ? id : '');
      const firstMissingColor = this.state.variantIds.findIndex((id) => !id);
      this.activeColorIndex = this.state.colorMode === 'same' ? 0 : Math.max(firstMissingColor, 0);
      this.unlock('colors');
      this.renderColors();
      if (!this.state.variantIds.every(Boolean)) return;
      this.state.engravings = Array.isArray(saved.engravings) ? saved.engravings.slice(0, this.state.quantity) : [];
      while (this.state.engravings.length < this.state.quantity) this.state.engravings.push('');
      const firstInvalidEngraving = this.state.engravings.findIndex((engraving) => !this.isValidEngraving(engraving));
      this.activeEngravingIndex = Math.max(firstInvalidEngraving, 0);
      this.unlock('engraving');
      this.renderEngravings();
      if (!this.state.engravings.every((engraving) => this.isValidEngraving(engraving))) return;
      this.unlock('sleeve');
      this.setProgress(4, 'sleeve');
      this.state.sleeveChoice = ['yes', 'no'].includes(saved.sleeveChoice) ? saved.sleeveChoice : '';
      this.state.sleeveQuantity = Math.min(Math.max(Number(saved.sleeveQuantity) || 0, 0), this.state.quantity);
      this.state.sleeveColorMode = ['same', 'split'].includes(saved.sleeveColorMode) ? saved.sleeveColorMode : '';
      this.state.sleeveColorCounts = {};
      Object.entries(saved.sleeveColorCounts || {}).forEach(([variantId, count]) => {
        const safeCount = Math.max(0, Math.floor(Number(count) || 0));
        if (safeCount > 0 && this.sleeveVariantById(variantId)?.available) this.state.sleeveColorCounts[String(variantId)] = safeCount;
      });
      if (this.state.sleeveChoice === 'yes') {
        const yes = this.querySelector('[data-sleeve-choice][value="yes"]');
        if (yes) yes.checked = true;
        this.renderSleeveOptions();
      } else if (this.state.sleeveChoice === 'no') {
        const no = this.querySelector('[data-sleeve-choice][value="no"]');
        if (no) no.checked = true;
      }
      if (this.state.sleeveChoice === 'no' || (this.state.sleeveChoice === 'yes' && this.sleevesComplete())) {
        this.unlock('summary');
        this.renderSummary();
        this.setProgress(5, 'summary');
      }
    }

    showStatus(message) {
      if (this.refs.status) this.refs.status.textContent = message || '';
    }

    showCartError(message) {
      this.refs.cartError.textContent = message || '';
      this.refs.cartError.hidden = false;
    }

    escape(value) {
      return String(value ?? '').replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
    }
  }

  if (!customElements.get('sidefill-engraving-funnel')) {
    customElements.define('sidefill-engraving-funnel', SidefillEngravingFunnel);
  }

  } catch(e) { console.error(e); }
})();
})();
